export default __webpack_public_path__ + "static/media/266.9aa3ec38.png";